import React from "react";
import { ProfileBookingLinkView } from "./view";
import { styles } from "./styles";

export const ProfileBookingLink = props => (
  <ProfileBookingLinkView {...props} styles={styles} />
);
